import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import moment from 'moment';

const PrintHeader = ({ company, header, transportAccount, customer,userinfo }) => (
  <div className="print-header">
    <table>
    <tbody>
      <tr>
        <td rowSpan={3}><img src="/company.png" alt="Company Logo" style={{ width: 'auto', height: '120px', marginRight: '20px' }} /></td>
        <td style={{ textAlign: 'right' }}> {header.page} </td>
      </tr>
      <tr>
        <td style={{ textAlign: 'right' }}>({header.title})</td>
      </tr>

      <tr>
        <td style={{ textAlign: 'right' }}><h3>{header.name}</h3></td>
      </tr>
      </tbody>
    </table>

    {/* <table >
            <tr>
              <th></th>
              <th>


              </th>
            </tr>
          </table> */}
    <table className='table header-table mt-2'>
      <tr>
        <td style={{ width: "40%", borderBottom: "1px solid #ccc" }}>
          <table >
          <tbody>
            <tr>
              <th style={{ width: "25%" }}>ผู้ขาย: </th>
              <th>{company.name}</th>
            </tr>
            <tr>
              <th>ที่อยู่: </th>
              <td>{company.address}</td>
            </tr>
            <tr>
              <th>เลขที่ภาษี: </th>
              <td>{company.taxid}</td>
            </tr>
            </tbody>
          </table>

        </td>
        <td style={{ width: "30%", borderBottom: "1px solid #ccc" }} >
          <table >
          <tbody>
            <tr>
              <th style={{ width: "10%" }}><MDBIcon fas icon="phone-alt" /></th>
              <td>{company.phone}</td>
            </tr>
            <tr>
              <th><MDBIcon fas icon="envelope" /></th>
              <td>{company.email}</td>
            </tr>
            <tr>
              <th><MDBIcon fas icon="globe" /></th>
              <td>{company.website}</td>
            </tr>
            </tbody>
          </table>
        </td>

        <td style={{ width: "30%" }} >
          <table name="documenttable" className='table bordered' style={{ backgroundColor: '#eee' }}>

            <tr>
              <th>เลขที่เอกสาร: </th>
              <td>{transportAccount.name}</td>
            </tr>
            <tr>
              <th>วันที่ออก: </th>
              <td>{moment(transportAccount.billdateobj).format("DD/MM/YYYY")}</td>
            </tr>
           {!header.nodue && <tr>
              <th>วันครบกำหนด: </th>
              <td>{moment(transportAccount.duedateobj).format("DD/MM/YYYY")}</td>
            </tr>}
      
          </table>
        </td>
      </tr>
      <tr >
        <td style={{ width: "40%" }}>
          <table >
            <tbody>
            <tr>
              <th style={{ width: "25%" }}>ลูกค้า: </th>
              <th>{customer.customer_id +' '+customer.name}</th>
            </tr>
            <tr>
              <th>ที่อยู่: </th>
              <td>{customer.address}</td>
            </tr>
            <tr>
              <th>เลขที่ภาษี: </th>
              <td>{customer.tax}{customer.branch?` (${customer.branch})`:""}</td>
            </tr>
            </tbody>
          </table>

        </td>
        <td style={{ width: "30%" }} >
          <table >
          <tbody>
            <tr>
              <th style={{ width: "10%" }}><MDBIcon fas icon="phone-alt" /></th>
              <td>{customer.phone ?? "-"}</td>
            </tr>
            <tr>
              <th><MDBIcon fas icon="envelope" /></th>
              <td>{customer.email ?? "-"}</td>
            </tr>
            <tr>
              <th><MDBIcon fas icon="globe" /></th>
              <td>{customer.website ?? "-"}</td>
            </tr>
            </tbody>
          </table>
        </td>

        <td style={{ width: "30%" }} >
          <table>
          <tbody>
            <tr>
              <th colSpan={2}>ติดต่อกลับที่: </th>

            </tr>
            <tr>
              <th><MDBIcon fas icon="user" /></th>
              <td>{userinfo.name}</td>
            </tr>
            <tr>
              <th><MDBIcon fas icon="envelope" /></th>
              <td>{userinfo.tel}</td>
            </tr>
            <tr>
              <th><MDBIcon fas icon="globe" /></th>
              <td>{userinfo.email}</td>
            </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </table>

  </div>
);

export default PrintHeader;